// extracted by mini-css-extract-plugin
export default {"RectangleStart":"EditIcon_RectangleStart__v-Szt","RectangleEnd":"EditIcon_RectangleEnd__3ZvJ5","Edit":"EditIcon_Edit__SbxrL"};